import { Text, StyleSheet } from "react-native";

export const MaterialIcons = ({ style, name, size, color }) => {
  const iconData = require('../assets/vectoricons/definitions/MaterialIcons.json');

    //const textstyle =
    //style ? (Array.isArray(style) ? Object.assign({}, ...style) : style):undefined;

    const unicode = iconData[name];
    
    const iconChar = (code) => {
      return String.fromCharCode(code);
    }

    return (
      <Text style={[style, { color: color, fontFamily: "MaterialIcons", fontSize: size }]}>
        {iconChar(unicode)}
      </Text>
  );
};
export const Ionicons = ({ style, name, size, color }) => {
  const iconData = require('../assets/vectoricons/definitions/Ionicons.json');

    //const textstyle =
    //style ? (Array.isArray(style) ? Object.assign({}, ...style) : style):undefined;

    const unicode = iconData[name];
    
    const iconChar = (code) => {
      return String.fromCharCode(code);
    }

    return (
      <Text style={[style, { color: color, fontFamily: "Ionicons", fontSize: size }]}>
        {iconChar(unicode)}
      </Text>
  );
};
export const Feather = ({ style, name, size, color }) => {
  const iconData = require('../assets/vectoricons/definitions/Feather.json');

    //const textstyle =
    //style ? (Array.isArray(style) ? Object.assign({}, ...style) : style):undefined;

    const unicode = iconData[name];
    
    const iconChar = (code) => {
      return String.fromCharCode(code);
    }

    return (
      <Text style={[style, { color: color, fontFamily: "Feather", fontSize: size }]}>
        {iconChar(unicode)}
      </Text>
  );
};


const styles = StyleSheet.create({
  sendButton: {
    backgroundColor: "#407daf",
    padding: 20,
    borderRadius: 10,
    marginBottom: 30,
  },
  disabledButton: {
    backgroundColor: "#999999",
  },
  sendText: {
    textAlign: "center",
    fontWeight: "700",
    fontSize: 16,
    color: "#fff",
  },
});
